type PromoactionValidityDates = {
    validFrom: string;
    validUntil: string;
    isPermanent: boolean;
};

/**
 * Нормализует даты действия акции: начало — к началу дня, конец — к концу дня.
 * Для бессрочной акции конец действия пустой.
 *
 * @kind helper
 * @param dates - даты действия акции и признак бессрочности
 * @returns нормализованные ISO-строки начала и конца действия
 */
export function transformPromoactionValidity({ validFrom, validUntil, isPermanent }: PromoactionValidityDates): {
    validFrom: string;
    validUntil: string;
} {
    const from = new Date(validFrom);

    from.setHours(0, 0, 0, 0);

    let until: Date | null = null;

    if (!isPermanent) {
        until = new Date(validUntil);

        until.setHours(23, 59, 59, 999);
    }

    return {
        validFrom: from.toISOString(),
        validUntil: until ? until.toISOString() : '',
    };
}
